import { useEffect, useState } from "react";
import AnimatedScroll from "../../components/AnimatedScroll/AnimatedScroll";
import { fetchTourismFromApi } from "../../utils/contentApi";
import { safeJsonParse } from "../../utils/safeJson";

function Tourism() {
  document.title = "Carpe Diem - Tourisme";

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lightboxItem, setLightboxItem] = useState(null);

  useEffect(() => {
    if (!lightboxItem) {
      return;
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setLightboxItem(null);
      }
    };

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [lightboxItem]);

  useEffect(() => {
    let isMounted = true;

    const loadTourism = async () => {
      setLoading(true);

      const cached = localStorage.getItem("carpeDiemTourism");
      if (cached) {
        const parsed = safeJsonParse(cached, []);
        if (isMounted && Array.isArray(parsed)) {
          setItems(parsed.filter((item) => item?.isActive !== false));
        }
      }

      try {
        const payload = await fetchTourismFromApi();
        if (!isMounted) {
          return;
        }

        setItems(payload.filter((item) => item?.isActive !== false));
        localStorage.setItem("carpeDiemTourism", JSON.stringify(payload));
      } catch (_error) {
        // Keep cache fallback.
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadTourism();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="events-page-section tourism-page-section">
      <div className="events-page-shell WMContainer-sc">
        <AnimatedScroll>
          <div className="events-page-head">
            <p className="events-page-kicker">Carpe Diem</p>
            <h2 className="events-page-title">Tourisme</h2>
            <p className="events-page-subtitle">
              Découvrez les activités et lieux touristiques autour du Carpe
              Diem.
            </p>
          </div>
        </AnimatedScroll>

        {loading ? (
          <p className="events-page-state">
            Chargement des activités touristiques...
          </p>
        ) : items.length === 0 ? (
          <p className="events-page-state">
            Aucune activité touristique pour le moment.
          </p>
        ) : (
          <div className="events-page-list">
            {items.map((item, index) => (
              <AnimatedScroll key={item.id}>
                <article
                  className={`events-page-row${index % 2 === 1 ? " is-reversed" : ""}`}
                >
                  <div className="events-page-visual">
                    <button
                      type="button"
                      className="events-page-media-button"
                      onClick={() =>
                        setLightboxItem({
                          imageUrl: item.imageUrl,
                          title: item.title,
                        })
                      }
                      aria-label={`Ouvrir l'image ${item.title} en grand`}
                    >
                      <img
                        className="events-page-media"
                        src={item.imageUrl}
                        alt={item.title}
                        loading="lazy"
                      />
                    </button>
                  </div>

                  <div className="events-page-content">
                    <h3>{item.title}</h3>
                    <p className="events-page-description">
                      {item.description ||
                        "Plus d'informations à venir sur cette activité."}
                    </p>
                    {item.link ? (
                      <a
                        className="tourism-external-link"
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        En savoir plus →
                      </a>
                    ) : null}
                  </div>
                </article>
              </AnimatedScroll>
            ))}
          </div>
        )}

        {lightboxItem ? (
          <div
            className="events-lightbox-overlay"
            role="dialog"
            aria-modal="true"
            onClick={() => setLightboxItem(null)}
          >
            <figure
              className="events-lightbox-content"
              onClick={(event) => event.stopPropagation()}
            >
              <button
                type="button"
                className="events-lightbox-close"
                aria-label="Fermer l'image"
                onClick={() => setLightboxItem(null)}
              >
                ×
              </button>

              <img
                className="events-lightbox-image"
                src={lightboxItem.imageUrl}
                alt={lightboxItem.title}
              />
              <figcaption className="events-lightbox-caption">
                {lightboxItem.title}
              </figcaption>
            </figure>
          </div>
        ) : null}
      </div>
    </section>
  );
}

export default Tourism;
